import * as React from "react";
import { Button, Row, Col, Modal } from "antd";
import { useTranslation } from "react-i18next";
// import { FontAwesomeIcon } from "./../../@fortawesome/react-fontawesome"
import { PhoneOutlined, MailOutlined } from "@ant-design/icons";

// reducers and redux
import { useDispatch, useSelector } from "react-redux";
import { getConfig } from "../../redux/main/mainActions";

import "./Footer.less";

type FooterProps = {
  contactText?: string;
};

export default function Footer({ contactText }: FooterProps) {
  const { t } = useTranslation();

  // Redux call contactdetails
  const reduxDispatch = useDispatch();
  React.useEffect(() => {
    reduxDispatch(getConfig());
  }, [reduxDispatch]);

  const config = useSelector((state: any) => state.main.config);

  const aboutInfo = () => {
    Modal.info({
      title: t("footer.about"),
      //   wrapClassName: "modal-about",
      maskClosable: true,
      content: (
        <div>
          <p>Prequest</p>
          <p>
            {t("footer.version")}: {config.version}
          </p>
        </div>
      ),
      onOk() {},
    });
  };

  const contactInfo = () => {
    Modal.info({
      title: t("footer.contact"),
      //   wrapClassName: "modal-contact",
      // icon: (
      //   <FontAwesomeIcon
      //     icon={["fal", "comment-alt-lines"]}
      //     className="anticon anticon-info-circle"
      //   />
      // ),
      maskClosable: true,
      content: (
        <div>
          <p>{t("footer.contactUs")}</p>
          <p>
            <a href={"tel:" + config.contact.contactNumber} rel="nofollow">
              <PhoneOutlined className="footer-icon-contact" />
              {config.contact.contactNumber}
            </a>
          </p>
          <p>
            <a
              href={"mailto:" + config.contact.contactMail}
              target="_blank"
              rel="noopener noreferrer"
            >
              <MailOutlined className="footer-icon-contact" />
              {config.contact.contactMail}
            </a>
          </p>
        </div>
      ),
      onOk() {},
    });
  };

  return (
    <>
      <div className="footer">
        <div className="footer-container">
          <Row justify="space-around" align="middle">
            <Col span={8}>
              <div className="footer-links">
                {config.myPrequestUrl && (
                  <a
                    href={config.myPrequestUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    myPrequest
                  </a>
                )}
                {config.version && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      aboutInfo();
                    }}
                    href="#about"
                  >
                    {t("footer.about")}
                  </a>
                )}
              </div>
            </Col>
            <Col span={8}>
              <div className="footer-copyright">
                <span>Prequest ©2020. All rights reserved</span>
              </div>
            </Col>
            <Col span={8}>
              <div className="footer-contact">
                {contactText && (
                  <Button
                    shape="round"
                    href="#"
                    size="middle"
                    // icon={
                    // <FontAwesomeIcon
                    //   icon={["fal", "comment-alt-lines"]}
                    //   className="icon"
                    // />
                    // }
                    onClick={(e) => {
                      e.preventDefault();
                      contactInfo();
                    }}
                  >
                    {contactText || t("footer.help")}
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
